import antdPtBR from 'antd/es/locale/pt_BR'

import datePickerTranstale from '../locales/datepickerTranslate.json'
import enMessages from '../locales/pt_BR.json'

const ptBr = {
  messages: {
    ...enMessages
  },
  antd: antdPtBR,
  locale: 'pt-BR',
  datePickerTranstale: {
    ...datePickerTranstale
  }
}
export default ptBr
